var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"变更记录","width":"80%","visible":_vm.visible,"maskClosable":false,"footer":null},on:{"cancel":_vm.close}},[_c('ls-api-table',{ref:"changeDataTable",attrs:{"columns":_vm.columns,"pagination":false,"tableProps":_vm.tableProps,"data-source":_vm.tableData,"rowKey":"id","scroll":{ y: 400 }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }